var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isBusy),expression:"isBusy"}]},[_c('TableDeduction',{attrs:{"deduction-list":_vm.deductionList,"lesson":_vm.lesson},on:{"get-list-deduction":_vm.getDeduction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }